// extracted by mini-css-extract-plugin
module.exports = {"details_share":"DetailsShare_details_share__1Yzlp","shareBTN":"DetailsShare_shareBTN__31UYI"};